import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://wfngafziivlcdeolbywe.supabase.co'
const SUPABASE_KEY = 'sb_publishable_7oz5j3zQlC1xp-hORgBZPw_eHYibbNE'

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY)
